import { Interface } from '@ethersproject/abi'
import { BigNumber } from '@ethersproject/bignumber'
import { EXECUTE_BUY_GAS_LIMIT, ChainId, DELAY_ABI, DELAY_ADDRESS, NATIVE_CURRENCY, toToken } from '../constants'
import { CurrencyValue } from '../model'
import { getSwapFeeDisplay } from '../pages/swap/getSwapDisplays'
import { Settings } from '../providers'
import { BuyInfo } from '../providers/transactions/model'

export function getBuyTransaction(
  account: string,
  chainId: ChainId,
  firstValue: CurrencyValue,
  secondValue: CurrencyValue,
  firstValueWithSlippage: CurrencyValue,
  gasPrice: BigNumber,
  fees: CurrencyValue | undefined,
  settings: Settings
) {
  const tokenIn = toToken(firstValue.currency)
  const tokenOut = toToken(secondValue.currency)
  const valueIn = firstValueWithSlippage.value
  const valueOut = secondValue.value
  const wrapUnwrap =
    firstValue.currency === NATIVE_CURRENCY[chainId] || secondValue.currency === NATIVE_CURRENCY[chainId]
  const etherValue = firstValue.currency === NATIVE_CURRENCY[chainId] ? firstValueWithSlippage.value : 0
  const safeGasLimit = EXECUTE_BUY_GAS_LIMIT + settings.gasLimitOverpay
  const nowSeconds = Math.floor(Date.now() / 1000)
  const safeGasPrice = gasPrice.mul(settings.gasPriceMultiplier).div(1000)
  const gasPrepay = safeGasPrice.mul(safeGasLimit)
  const txInfo = {
    type: 'BUY',
    currencyIn: tokenIn.serialize(),
    currencyOut: tokenOut.serialize(),
    maxValueIn: firstValueWithSlippage.format(),
    expectedValueIn: firstValue.format(),
    valueOut: secondValue.format(),
    gasPrepay: gasPrepay.toString(),
    slippageTolerance: settings.slippageTolerance.toString(),
    fees: getSwapFeeDisplay(fees),
  } as BuyInfo
  return {
    to: DELAY_ADDRESS[chainId],
    data: new Interface(DELAY_ABI).encodeFunctionData('buy', [
      {
        tokenIn: tokenIn.address,
        tokenOut: tokenOut.address,
        amountInMax: valueIn,
        amountOut: valueOut,
        wrapUnwrap,
        to: account,
        gasLimit: safeGasLimit,
        submitDeadline: nowSeconds + settings.submitDeadline,
        executionDeadline: nowSeconds + settings.executionDeadline,
      },
    ]),
    value: gasPrepay.add(etherValue),
    txInfo,
  }
}
